import React from 'react';
import moment from 'moment-timezone';
import * as Yup from "yup";

const codingEventInitData = {
    worksheets: [],
    documents: [],
    notes: [],
    id: 0,
    customerAccountName: '',
    description: '',
    lineOfBusinessId: 0,
    customerContactId: 0,
    isBillable: false,
    codingEventQueueId: 0,
    eventPriorityId: 0,
    receivedOn: moment().tz('America/Chicago'),
    dueBy: moment().tz('America/Chicago'),
    statusId: 100,
    statusReason: '',
    clinicianId: null,
    clinicalManagerId: null,
    serviceRequestId: 0,
    assignedToId: null,
    description: '',
    newNote: ''
};

const getContactInfo = (id, contacts) => {
    var result = contacts.filter(obj => {
        return obj.id === id;
    });
    if (result.length > 0) {
        return (
            <> {result[0].fullName} <br /> {result[0].emailAddress} <br /> {result[0].phoneNumber}</>
        );
    }
    return <> Undefined contact<br />&nbsp;<br />&nbsp;</>;
}

const codingEventValidationSchema = {
    lineOfBusinessId: Yup.number().required('Line of business is required.')
        .min(1, 'Line of business is required.'),
    customerContactId: Yup.number().nullable().required('Customer Contact is required.'),
    codingEventQueueId: Yup.number().required('Queue is required.'),
    eventPriorityId: Yup.number().required('Priority is required.'),
    serviceRequestId: Yup.number().nullable().required('Service type is required.'),
    description: Yup.string().required('Description is required.')
        .min(10, 'Description must be at minimum 10 characters long.')
        .max(1000, 'Description must be 1000 characters or less.'),
    statusId: Yup.number().required('Status is required.'),
    statusReason: Yup.string().nullable().when("statusId", {
        is: statusId => statusId === 400,
        then: Yup.string().nullable().required('Status reason is required.')
    }),
    clinicianId: Yup.number().nullable().when("statusId", {
        is: statusId => statusId === 1000,
        then: Yup.number().nullable().required('Clinician is required to complete the event.')
    }),
    //clinicalManagerId: Yup.number().nullable().when("statusId", {
    //    is: statusId => statusId === 1000,
    //    then: Yup.number().nullable().required('Clinical Manager is required to complete the event.')
    //}),
    newNote: Yup.string().max(0, 'You must save your new note before saving the event.')
};

export { codingEventInitData, codingEventValidationSchema, getContactInfo }